import type { ColumnDef } from "@tanstack/react-table";
import type { ApEmail } from "@/accounts-payable/types";
import { formatApDateTime } from "@/accounts-payable/utils";

export const receivedCol: ColumnDef<ApEmail> = {
  accessorKey: "received_at",
  header: "Received",
  meta: { size: "150px" },
  cell: ({ row }) => (
    <span className="text-tertiary-text">
      {formatApDateTime(row.original.received_at)}
    </span>
  ),
};
